import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import Loader from "../../Loader/Loader";
import NotAnAdmin from "../../SettingsContainer/NotAnAdmin";
import { responseRolesRequired } from "../../Sidebar/Menu/Menu";
import { setActiveModule } from "../../../actions/sideBarActions";
import SMRDashboardPage from "../SMRAnalytics/SMRDashboards/SMRDashboardPage";

const LoadableSMR = lazy(() => import("./SMR"));
const LoadableSMRSettings = lazy(() => import("../SMRSettings/SMRSettingsRoutes"));
// const LoadableSMRSFIntegartions = lazy(() => import("../SMRSFIntegration/Settings"));
// const LoadableSMRRules = lazy(() => import("../SMRRules/SMRRules"));
const LoadableSMRAnalytics = lazy(() => import("../SMRAnalytics/SMRAnalytics"));
const LoadableSMRReports = lazy(() => import("../SMRReports/Reports"));
const LoadableCreateReport = lazy(() => import("../SMRReports/CreateReport/CreateReport"));
// const LoadableSMRCanned = lazy(() => import("../SMRCanned/SMRCannedResponse"));
// const LoadableSMRSurvey = lazy(() => import("../SMRSurvey/SMRSurveyRoutes"));
const LoadableSyncedTickets = lazy(() => import("./KeywordSyncedTickets/KeywordSyncedTickets"));
// const LoadableDashboardPage = lazy(() => import("../Dashboard/DashboardPage"));

const SMRRoutes = (props) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.globalReducer.user);
    const packageObj = useSelector((state) => state.globalReducer.packageObj);
    const activeModule = useSelector((state) => state.sidebarReducer.activeModule);

    useEffect(() => {
        if (activeModule !== "Response" && responseRolesRequired.some((role) => user?.roles.includes(role))) {
            localStorage.setItem("activeModule", "Response");
            dispatch(setActiveModule("Response"));
        }
    }, []);

    return (
        <>
            {packageObj?.features?.smr_module_access?.quota === 1 || packageObj.package_code === "free" ? (
                <Suspense fallback={<Loader />}>
                    <Switch>
                        <Route path="/social-response/inbox" component={LoadableSMR} />
                        <Route path="/social-response/inbox/thread/:id" component={LoadableSMR} />
                        <Route path="/social-response/settings" component={LoadableSMRSettings} />
                        {/* <Route path="/social-response/integrations" component={LoadableSMRSFIntegartions} /> */}
                        {/* <Route path="/social-response/filters" component={LoadableSMRRules} /> */}
                        {/* <Route path="/social-response/analytics" component={LoadableSMRAnalytics} /> */}
                        <Route path="/social-response/reports" component={LoadableSMRReports} />
                        <Route path="/social-response/create-report" component={LoadableCreateReport} />
                        <Route path="/social-response/edit-report" render={(props) => <LoadableCreateReport {...props} isEditPage />} />
                        <Route path="/social-response/dashboard" exact component={SMRDashboardPage} />
                        <Route path="/social-response/dashboard/:dashboardType" component={LoadableSMRAnalytics} />
                        {/* <Route path="/social-response/canned" component={LoadableSMRCanned} /> */}
                        {/* <Route path="/social-response/survey" component={LoadableSMRSurvey} /> */}
                        <Route path="/social-response/keyword-synced-tickets" component={LoadableSyncedTickets} />
                        {/* <Route
                            path="/social-response/keyword-synced-tickets"
                            render={(props) => <LoadableDashboardPage {...props} dashboardPageType={"smrKeywordSync"} />}
                        /> */}
                        <Redirect to="/social-response/inbox" />
                    </Switch>
                </Suspense>
            ) : (
                <NotAnAdmin {...props} className="with-margin" companyLevelAccessDenied />

                // <NotAnAdmin {...props} companyLevelAccessDenied />
            )}
        </>
    );
};

export default SMRRoutes;
